export const GET_DATA_SEARCH = "GET_DATA_SEARCH";
export const SAVE_SEARCH_VALUE = "SAVE_SEARCH_VALUE";

export const SET_DATA_SEARCH_FILTER = "SET_DATA_SEARCH_FILTER";
export const GET_DATA_SEARCH_ADVANCE = "GET_DATA_SEARCH_ADVANCE";
export const SET_VISIBLE_MODAL_ADV = "SET_VISIBLE_MODAL_ADV";
export const RESET_SEARCH = "RESET_SEARCH";
